import React from 'react';

export default () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.3916 14.6089C5.63568 14.853 6.03131 14.853 6.27539 14.6089L13.5418 7.34245V14.167C13.5418 14.5122 13.8217 14.792 14.1668 14.792C14.512 14.792 14.7918 14.5122 14.7918 14.167V5.83366C14.7918 5.48848 14.512 5.20866 14.1668 5.20866H5.8335C5.48832 5.20866 5.2085 5.48848 5.2085 5.83366C5.2085 6.17884 5.48832 6.45866 5.8335 6.45866H12.658L5.3916 13.7251C5.14752 13.9692 5.14752 14.3648 5.3916 14.6089Z"
        fill="#05A8FD"
      />
      <path
        d="M5.3916 14.6089C5.63568 14.853 6.03131 14.853 6.27539 14.6089L13.5418 7.34245V14.167C13.5418 14.5122 13.8217 14.792 14.1668 14.792C14.512 14.792 14.7918 14.5122 14.7918 14.167V5.83366C14.7918 5.48848 14.512 5.20866 14.1668 5.20866H5.8335C5.48832 5.20866 5.2085 5.48848 5.2085 5.83366C5.2085 6.17884 5.48832 6.45866 5.8335 6.45866H12.658L5.3916 13.7251C5.14752 13.9692 5.14752 14.3648 5.3916 14.6089Z"
        fill="#05A8FD"
      />
    </svg>
  );
};
